import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { CreateShopStepHeadingProps } from "./CreateShopStepHeading.types";
import * as styles from "./CreateShopStepHeading.styles";

export function CreateShopStepHeading({
  titleKey,
  subtitleKey,
  mobileSubtitleKey,
  values,
}: CreateShopStepHeadingProps) {
  const { t } = useTranslation("shops");

  return (
    <Box sx={styles.root}>
      <Typography sx={styles.title}>{t(titleKey)}</Typography>
      <Typography sx={styles.subtitle}>
        <Box component="span" sx={styles.mobileOnly}>
          {t(mobileSubtitleKey ?? subtitleKey, values)}
        </Box>
        <Box component="span" sx={styles.desktopOnly}>
          {t(subtitleKey, values)}
        </Box>
      </Typography>
    </Box>
  );
}
